import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { LOGIN_ROUTE } from "../../config/RoutesConstants"
import { 
  Container, 
  Box, 
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  IconButton,
  InputLabel,
  Fab,
  FormControl,
  Grid,
  GridList,
  GridListTile,
  Paper,
  Typography, 
  Tooltip,
  Input,
  Icon,
  Toolbar,
  MenuItem,  
  Select,
  Tab,
  Tabs,
  Table,
  TableRow,
  TableCell,
  TableSortLabel,
  TableHead,
  TableBody,
  TablePagination,
  TextField

} from "@material-ui/core"
import { withTheme } from "@material-ui/core/styles"
import BackIcon from '@material-ui/icons/ArrowBackRounded';
import ArrowRightIcon from '@material-ui/icons/ChevronRight'
import Util, { ERROR, SUCCESS } from '../../common/Util'
import Settings from "../../provider/base/Settings"
import { actionGetStatsByClient } from "../../actions/StatsActions"
import { actionGetStatsByClientDetail, actionGetStatsByRRPPDetail } from "../../actions/StatsActions"

import moment from "moment"

import SearchIcon from '@material-ui/icons/Search';
// import ClearIcon from '@material-ui/icons/Backspace';
import RefreshIcon from '@material-ui/icons/Sync';
import DetailIcon from '@material-ui/icons/List';
import StatsByClientTab from "./StatsByClientTab"
import StatsByClientDetail from "./StatsByClientDetail"
import StatsByEventTab from "./StatsByEventTab"
import StatsByRRPPTab from "./StatsByRRPPTab"
import StatsByRRPPDetail from "./StatsByRRPPDetail"

class Statistics extends React.PureComponent{
  constructor(props){
    super(props)
    let lastMonth = moment()
    lastMonth = lastMonth.add(-1,"month").format("YYYY-MM-DD")
    let today = moment().format("YYYY-MM-DD")
    let filter = {from:lastMonth, to:today, period:"daily", place:""}
    this.state = {count:0, rowPerPage:10, page:1, orderBy:"Qt", orderDesc:true, filter:filter, tabIndex:0, detailInitFilter:null}
    this.onChangeTab = this.onChangeTab.bind(this)
    this.onPressDetailUser = this.onPressDetailUser.bind(this)
    this.onPressDetailRRPP = this.onPressDetailRRPP.bind(this)
  }

  componentWillMount(){
    if(!this.props.login){
      this.props.history.replace(LOGIN_ROUTE);      
    }
  }
 
  onChangeTab(evt, value){
		this.setState({tabIndex:value, page:0}); 
	}

  onPressDetailUser(user, filter){
    this.props.actionGetStatsByClientDetail({...filter, tktBuyerDU:user.tktBuyerDU}, {}, ()=>{
      this.setState({detailUser:user, detailInitFilter:filter})
    },
    (e)=>{
      console.log("ERROR GET Client detail", e)
      if(!(e&&e.status&&e.status==401))
        Util.showNoty(ERROR, "Ocurrió un error al consultar el detalle.")
    })
  }

  onPressDetailRRPP(rrpp, filter){
    console.log("onPressDetailRRPP", rrpp, filter)
    this.props.actionGetStatsByRRPPDetail({...filter, tktRrpp:rrpp.tktRrpp}, {}, ()=>{
      this.setState({detailRrpp:rrpp, detailInitFilter:filter})
    },
    (e)=>{
      console.log("ERROR GET RRPP Detail", e)
      if(!(e&&e.status&&e.status==401))
        Util.showNoty(ERROR, "Ocurrió un error al consultar el detalle.")
    })
  }


  render(){
    const { theme, handleSubmit, history, placeList} = this.props
    const { detailUser,detailInitFilter, detailRrpp } = this.state
    return (
      <Box style={theme.mainContainer}>
        <Box style={{...theme.title.container, flexDirection:"row", display:"flex"}}>
          <Box style={theme.title.backIconContainer}>
            <IconButton onClick={this.props.history.goBack} style={theme.title.backIcon}>
              <BackIcon style={{fontSize:"2.5rem"}} stroke="white" strokeWidth={3} strokeLinecap="round" strokeLinejoin="round"/>
            </IconButton>
          </Box>
          <Box>
            <Typography variant="h1">Estadísticas</Typography>
            
          </Box>
        </Box>
        <Container maxWidth={1320}>        
          <Tabs indicatorColor="primary" value={this.state.tabIndex} onChange={this.onChangeTab}>
            <Tab label="Por Cliente" />
            <Tab label="Por Evento"/>
            <Tab label="Por RRPP"/>
          </Tabs>
          {this.state.tabIndex==0&&<StatsByClientTab onPressDetail={this.onPressDetailUser}/>}
          {this.state.tabIndex==1&&<StatsByEventTab/>}
          {this.state.tabIndex==2&&<StatsByRRPPTab onPressDetail={this.onPressDetailRRPP}/>}
        </Container>
        <StatsByClientDetail 
                            user={detailUser}
                            filter={detailInitFilter}
                            onClose={()=>{this.setState({detailUser:null,detailInitFilter:null})}}/>
        <StatsByRRPPDetail 
                            user={detailRrpp}
                            filter={detailInitFilter}
                            onClose={()=>{this.setState({detailRrpp:null,detailInitFilter:null})}}/>
      </Box>
    )
  }
}
function mapStateToProps(store) {
  console.log("STORE STATISTICS", store)
  return {
    login: store.auth.login,
    statsByClient:store.stats.statsByClient,
    placeList: store.plc.placeList

   
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      actionGetStatsByClient,
      actionGetStatsByClientDetail,
      actionGetStatsByRRPPDetail
    },
    dispatch
  );
}

// Statistics.defaultProps = {
//   stats:{
//     statsTotalQtSell:50,
//     statsTotalQt:1000,
//     statsTotalAmmountProducer:22000,
//     statsTotalAmmount:27000,
//     statsTotalQtSellByRRPP:1100 //transient
//   }
// }

export default withRouter(
    withTheme(
      connect(
        mapStateToProps,
        mapDispatchToProps
      )(Statistics)
    )
  )


// WEBPACK FOOTER //
// ./src/screens/statistics/Statistics.js